import {FileSizeType} from '../constants';
import {FileSizeTypeLabel} from '../locales';

export const getFileSizeTypeLabel = (type: FileSizeType) =>
	FileSizeTypeLabel[type];

export default getFileSizeTypeLabel;
